import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule as PMultiSelectModule } from 'primeng/multiselect';
import { InfinityMultiSelectComponent } from './infinity-multi-select.component';

@NgModule({
  imports: [
    CommonModule,
    PMultiSelectModule,
    FormsModule,
    InfinityMultiSelectComponent,
  ],
  exports: [InfinityMultiSelectComponent],
})
export class InfinityMultiSelectModule {}
